/*
 * Yachew navigation behaviour (styles: assets/yc-menu.css).
 *
 * Desktop mega-menu (snippets/yc-mega-menu.liquid)
 * - Rail hover switches the right pane, with "menu aim": while the pointer is
 *   heading right towards the pane, crossing other rail items doesn't switch.
 * - Keyboard: Tab from a rail item goes into its pane's links, Tab off the end of
 *   a pane goes to the next rail item; Escape closes the panel.
 * - A panel left open by focus (e.g. after a Cmd/Ctrl-click) closes on mouse-out.
 * - Moving between departments swaps panels instantly (no fade-through).
 *
 * Drawer: the "All departments" back row closes a department's slide-in panel.
 */
(function () {
  if (window.__ycMenu) return;
  window.__ycMenu = true;

  // ---------- desktop ----------
  var moves = [];
  function track(e) {
    moves.push({ x: e.clientX, y: e.clientY, t: Date.now() });
    if (moves.length > 6) moves.shift();
  }
  document.addEventListener('mousemove', track, { passive: true });

  // Is the pointer moving into the triangle between where it was and the pane's left edge?
  function headingToPane(pane) {
    // Only recent movement counts: a pointer that paused isn't "heading" anywhere.
    var now = Date.now();
    var recent = moves.filter(function (m) { return now - m.t < 120; });
    if (recent.length < 2) return false;
    var r = pane.getBoundingClientRect();
    var prev = recent[0];
    var cur = recent[recent.length - 1];
    if (cur.x <= prev.x) return false;
    var tl = { x: r.left, y: r.top - 40 };
    var bl = { x: r.left, y: r.bottom + 40 };
    var slope = function (a, b) { return (b.y - a.y) / (b.x - a.x); };
    return slope(cur, tl) < slope(prev, tl) && slope(cur, bl) > slope(prev, bl);
  }

  function initMega(mm, nav) {
    var item = mm.closest('.yc-mm-item');
    var top = item && item.querySelector('.header-inline-menu__item-link');
    var list = mm.querySelector('.yc-mm__tabs');
    var paneWrap = mm.querySelector('.yc-mm__panes');
    var tabs = Array.prototype.slice.call(mm.querySelectorAll('[data-yc-mm-tab]'));
    var panes = mm.querySelectorAll('[data-yc-mm-pane]');
    var timer = null;
    if (!item || !tabs.length) return;

    // Promo card follows the shown category: its 7th best seller (the first 6 are listed in the pane).
    var promo = mm.querySelector('[data-yc-promo]');
    var promoDefault = promo && { html: promo.innerHTML, href: promo.getAttribute('href') };
    mm.__ycSetPromo = function (pane) {
      if (!promo) return;
      var p = pane && pane.__ycPromo;
      if (!p) {
        // A category still loading keeps the card that's showing (no blink); it swaps when ready. Quick panes
        // (New / Coming Soon / Bestsellers) and categories without a promo product get the department card.
        var quick = pane && pane.classList.contains('yc-mm__pane--quick');
        if (!quick && pane && pane.querySelector('[data-yc-mm-top]') && !pane.__ycNoPromo) return;
        if (promo.__ycShowing === 'default') return;
        promo.__ycShowing = 'default';
        promo.innerHTML = promoDefault.html; promo.setAttribute('href', promoDefault.href); return;
      }
      if (promo.__ycShowing === p) return;
      promo.__ycShowing = p;
      promo.setAttribute('href', p.href);
      var media = promo.querySelector('.yc-mm__promo-media');
      var title = promo.querySelector('.yc-mm__promo-title');
      if (media) media.innerHTML = p.img;
      if (title) title.textContent = p.title;
      var badge = promo.querySelector('.yc-mm__badge');
      var cta = promo.querySelector('.yc-mm__promo-cta');
      if (badge) badge.textContent = promo.getAttribute('data-yc-badge');
      if (cta) cta.innerHTML = promo.getAttribute('data-yc-cta') + ' <span aria-hidden="true">→</span>';
    };

    // The pane open by default is the first category (the New / Coming Soon / Bestsellers rows sit above it).
    var defaultId = (mm.querySelector('.yc-mm__tab.is-active') || tabs[0]).getAttribute('data-yc-mm-tab');
    function show(id) {
      tabs.forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-yc-mm-tab') === id); });
      panes.forEach(function (p) {
        var on = p.getAttribute('data-yc-mm-pane') === id;
        p.classList.toggle('is-active', on);
        if (on) { loadTop(p); mm.__ycSetPromo(p); }
      });
    }
    function paneFor(id) { return mm.querySelector('[data-yc-mm-pane="' + id + '"]'); }
    function setExpanded(v) { if (top) top.setAttribute('aria-expanded', v ? 'true' : 'false'); }

    var lastAim = null;
    function aim(id) {
      clearTimeout(timer);
      var cur = moves[moves.length - 1];
      // Still heading for the pane and the pointer has moved since the last check: wait. Otherwise switch.
      if (headingToPane(paneWrap) && cur !== lastAim) {
        lastAim = cur;
        timer = setTimeout(function () { aim(id); }, 250);
      } else {
        lastAim = null;
        timer = setTimeout(function () { show(id); }, 40);
      }
    }

    tabs.forEach(function (tab, i) {
      var id = tab.getAttribute('data-yc-mm-tab');
      // mouseenter fires before the document's mousemove for the same move, so record it here first.
      tab.addEventListener('mouseenter', function (e) {
        track(e);
        var b = paneFor(id) && paneFor(id).querySelector('[data-yc-mm-top]');
        if (b) fetchTop(b.getAttribute('data-yc-mm-top'));
        aim(id);
      });
      tab.addEventListener('mouseleave', function () { clearTimeout(timer); lastAim = null; });
      tab.addEventListener('focus', function () { clearTimeout(timer); show(id); });
      tab.addEventListener('keydown', function (e) {
        // Up/Down move through the list; Right (or Tab) goes into the shown category's links.
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
          var next = tabs[i + (e.key === 'ArrowDown' ? 1 : -1)] || (e.key === 'ArrowUp' && mm.querySelector('.yc-mm__all'));
          if (next) { e.preventDefault(); next.focus(); }
          return;
        }
        if ((e.key !== 'Tab' || e.shiftKey) && e.key !== 'ArrowRight') return;
        var first = paneFor(id) && paneFor(id).querySelector('a');
        if (first) { e.preventDefault(); show(id); first.focus(); }
      });
    });

    var shopAll = mm.querySelector('.yc-mm__all');
    if (shopAll) shopAll.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown' && tabs[0]) { e.preventDefault(); tabs[0].focus(); }
    });

    panes.forEach(function (pane) {
      var id = pane.getAttribute('data-yc-mm-pane');
      var idx = tabs.findIndex(function (t) { return t.getAttribute('data-yc-mm-tab') === id; });
      pane.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft' && tabs[idx]) { e.preventDefault(); tabs[idx].focus(); return; }
        if (e.key !== 'Tab') return;
        var links = pane.querySelectorAll('a');
        if (!e.shiftKey && document.activeElement === links[links.length - 1] && tabs[idx + 1]) {
          e.preventDefault(); tabs[idx + 1].focus();
        } else if (e.shiftKey && document.activeElement === links[0]) {
          e.preventDefault(); tabs[idx].focus();
        }
      });
    });

    function reset() {
      clearTimeout(timer);
      show(defaultId);
      if (list) list.scrollTop = 0;
    }

    function fit() {
      // Fit the panel to the space left under the header.
      var row = item.closest('.header-row');
      if (row) mm.style.setProperty('--yc-mm-top', Math.max(0, Math.round(row.getBoundingClientRect().bottom)) + 'px');
    }
    function open() {
      item.classList.remove('yc-mm-closed');
      var active = mm.querySelector('.yc-mm__pane.is-active');
      if (active) setTimeout(function () { loadTop(active); }, 0);
      fit();
      // Keyboard focus can scroll the sticky header back into view first; measure again once it has.
      requestAnimationFrame(fit);
      nav.classList.add('yc-mm-open');
      clearTimeout(nav.__ycOpenTimer);
      setExpanded(true);
    }
    // Open / close. A panel opens after a short pause (150 ms, or 120 ms when swapping from another
    // department), so a pointer just crossing the bar doesn't flash panels. It closes 250 ms after
    // the pointer leaves the whole menu. Keyboard: Tab moves along the bar without opening anything;
    // Down arrow or Space opens a department and moves into its list; Escape closes.
    function closeAll() {
      nav.querySelectorAll('.yc-mm-item.is-open').forEach(function (o) { if (o.__ycClose) o.__ycClose(); });
      nav.classList.remove('yc-mm-open');
    }
    item.__ycClose = function () {
      item.classList.remove('is-open', 'yc-kbd');
      reset();
      setExpanded(false);
    };
    function openNow(kbd) {
      nav.querySelectorAll('.yc-mm-item.is-open').forEach(function (o) { if (o !== item && o.__ycClose) o.__ycClose(); });
      item.classList.add('is-open');
      item.classList.toggle('yc-kbd', !!kbd);
      open();
    }
    item.addEventListener('mouseenter', function () {
      clearTimeout(nav.__ycIntent);
      if (item.classList.contains('is-open')) return;
      var swapping = !!nav.querySelector('.yc-mm-item.is-open');
      nav.__ycIntent = setTimeout(function () { if (item.matches(':hover')) openNow(false); }, swapping ? 120 : 150);
    });
    item.addEventListener('mouseleave', function () {
      var a = document.activeElement;
      // A mouse click (incl. open-in-new-tab) leaves focus inside; it shouldn't pin the panel open.
      if (a && item.contains(a) && !a.matches(':focus-visible')) a.blur();
      clearTimeout(nav.__ycIntent);
      nav.__ycIntent = setTimeout(function () {
        if (nav.querySelector('.yc-mm-item:hover')) return;
        var f = document.activeElement;
        if (f && nav.contains(f) && f.matches(':focus-visible')) return; // keyboard user is still in it
        closeAll();
      }, 250);
    });
    // Touch screens at desktop width (iPad landscape, touch laptops): there's no hover, so the first tap
    // on a department opens its panel and a second tap follows the link.
    if (top) {
      top.addEventListener('pointerdown', function (e) { top.__ycTouch = e.pointerType === 'touch' || e.pointerType === 'pen'; });
      top.addEventListener('click', function (e) {
        if (!top.__ycTouch || item.classList.contains('is-open')) return;
        e.preventDefault();
        clearTimeout(nav.__ycIntent);
        openNow(false);
      });
    }
    document.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' && item.classList.contains('is-open') && !item.contains(e.target)) item.__ycClose();
    });
    if (top) top.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowDown' && e.key !== ' ') return;
      e.preventDefault();
      openNow(true);
      var first = mm.querySelector('.yc-mm__all') || tabs[0];
      setTimeout(function () { if (first) first.focus(); }, 0);
    });
    item.addEventListener('focusout', function (e) {
      if (item.contains(e.relatedTarget)) return;
      if (!item.matches(':hover')) item.__ycClose();
    });
    item.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      item.__ycClose();
      if (top) top.focus();
    });
  }

  // Top sellers for the shown category: fetched once per collection, kept for 30 minutes in
  // sessionStorage (so later pages show them at once), and prefetched while the pointer is on the bar.
  var topCache = {};
  var TTL = 30 * 60 * 1000;
  // Coming Soon panes ask for the collection's own order (soonest release first); everything else best-selling.
  function topUrl(url) { return url + (url.indexOf('?') < 0 ? '?' : '&') + (url.indexOf('sort_by=') < 0 ? 'sort_by=best-selling&' : '') + 'section_id=yc-mm-products'; }
  function fetchTop(url) {
    if (topCache[url]) return topCache[url];
    var key = 'yc-mm3:' + (window.Shopify && Shopify.country || '') + ':' + url;
    try {
      var hit = JSON.parse(sessionStorage.getItem(key) || 'null');
      if (hit && Date.now() - hit.t < TTL) return (topCache[url] = Promise.resolve(hit.h));
    } catch (e) { /* storage off */ }
    topCache[url] = fetch(topUrl(url), { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var list = doc.querySelector('.yc-mm-products');
        var h = list ? list.outerHTML : '';
        try { sessionStorage.setItem(key, JSON.stringify({ t: Date.now(), h: h })); } catch (e) { /* full or off */ }
        return h;
      });
    topCache[url].catch(function () { delete topCache[url]; });
    return topCache[url];
  }
  // Warm the first category of every department once the pointer reaches the department bar.
  function prefetchFirsts(nav) {
    if (nav.__ycWarm) return;
    nav.__ycWarm = true;
    var boxes = Array.prototype.slice.call(nav.querySelectorAll('.yc-mm__pane.is-active [data-yc-mm-top]'));
    var go = function () { boxes.forEach(function (b, i) { setTimeout(function () { fetchTop(b.getAttribute('data-yc-mm-top')); }, i * 120); }); };
    if (window.requestIdleCallback) requestIdleCallback(go, { timeout: 1500 }); else setTimeout(go, 200);
  }
  var SKEL = '<div class="yc-mm-products yc-mm-products--skel" aria-hidden="true">' + new Array(7).join('<span class="yc-mm-prod yc-mm-prod--skel"><span class="yc-mm-prod__img"></span><span class="yc-mm-prod__text"><span></span><span></span></span></span>') + '</div>';
  function loadTop(pane) {
    var box = pane.querySelector('[data-yc-mm-top]');
    if (!box || box.__ycLoaded || !box.closest('.yc-mm-item').matches('.is-open, :hover, :focus-within')) return;
    box.__ycLoaded = true;
    var url = box.getAttribute('data-yc-mm-top');
    var body = box.querySelector('[data-yc-mm-top-body]');
    var noPromo = function () {
      pane.__ycNoPromo = true;
      var mm = pane.closest('[data-yc-mm]');
      if (pane.classList.contains('is-active') && mm && mm.__ycSetPromo) mm.__ycSetPromo(pane);
    };
    var req = fetchTop(url);
    // Placeholder cards hold the space until the products arrive (only if they aren't already cached).
    var settled = false;
    req.then(function () { settled = true; }, function () { settled = true; });
    setTimeout(function () { if (!settled && !body.firstChild) { body.innerHTML = SKEL; box.hidden = false; } }, 0);
    req.then(function (h) {
      var list = new DOMParser().parseFromString(h, 'text/html').querySelector('.yc-mm-products');
      if (!list || !list.children.length) { body.innerHTML = ''; box.hidden = true; noPromo(); return; }
      body.innerHTML = '';
      body.appendChild(list);
      box.hidden = false;
      // Category panes (not New / Coming Soon / Bestsellers, which show all six) feed the promo card.
      if (!pane.classList.contains('yc-mm__pane--quick')) {
        var pick = list.children[6];
        var img = pick && pick.querySelector('img');
        if (!img) noPromo();
        if (img) {
          var clone = img.cloneNode();
          clone.className = 'yc-mm__promo-img';
          clone.setAttribute('sizes', '260px');
          clone.loading = 'eager';
          var ready = function () {
            pane.__ycPromo = { href: url + (url.indexOf('?') < 0 ? '?' : '&') + 'sort_by=best-selling', title: pane.getAttribute('data-yc-promo-title'), img: clone.outerHTML };
            var mm = pane.closest('[data-yc-mm]');
            if (pane.classList.contains('is-active') && mm && mm.__ycSetPromo) mm.__ycSetPromo(pane);
          };
          // Decode the bigger promo image first, so the card swaps in one go instead of flashing empty.
          if (clone.decode) clone.decode().then(ready, ready); else ready();
        }
      }
    }).catch(function () { box.__ycLoaded = false; body.innerHTML = ''; box.hidden = true; noPromo(); });
  }

  function init() {
    document.querySelectorAll('.header-inline-menu').forEach(function (nav) {
      nav.querySelectorAll('[data-yc-mm]').forEach(function (mm) { initMega(mm, nav); });
      nav.addEventListener('pointerenter', function () { prefetchFirsts(nav); }, { once: true });
    });
  }

  // ---------- drawer ----------
  document.addEventListener('click', function (e) {
    var back = e.target.closest && e.target.closest('[data-yc-back]');
    if (!back) return;
    e.preventDefault();
    var details = back.closest('details');
    var drawer = back.closest('header-drawer');
    if (!details) return;
    var summary = details.querySelector('summary');
    if (summary) summary.setAttribute('aria-expanded', 'false');
    // The theme's own close: slides out, drops the submenu focus trap and re-traps the drawer.
    if (drawer && typeof drawer.closeSubmenu === 'function') {
      drawer.closeSubmenu(details);
    } else {
      details.classList.remove('menu-opening');
      setTimeout(function () { details.removeAttribute('open'); }, 275);
    }
    setTimeout(function () { if (summary) summary.focus({ preventScroll: true }); }, 300);
  });

  // "Shipping to" row: open the drawer's region selector
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-yc-shipto]');
    if (!b) return;
    var drawer = b.closest('.menu-drawer');
    var summary = drawer && drawer.querySelector('#menu-drawer-localization > summary');
    if (!summary) return;
    summary.focus();
    summary.click();
    // Keyboard users land in the region panel, so Escape/Tab work there rather than behind it.
    setTimeout(function () {
      var region = summary.parentElement;
      if (region.contains(document.activeElement) && document.activeElement !== summary) return;
      var target = region.querySelector('.menu-drawer-localization-back-btn, .header-region-content button, .header-region-content a');
      if (target) target.focus({ preventScroll: true });
    }, 300);
  });

  // The drawer always reaches the bottom of the screen. base.css sizes it as 100dvh minus the header
  // height (plus the search bar), which leaves a gap at the bottom on Android Chrome when the header or
  // search bar has partly scrolled away (16 Oct 2026). Size it from where it actually starts instead.
  function fitDrawer() {
    var d = document.querySelector('header-drawer .menu-drawer');
    if (!d || !d.closest('details[open]')) return;
    var vh = window.visualViewport ? window.visualViewport.height : window.innerHeight;
    var top = d.getBoundingClientRect().top;
    if (top > 0 && vh > top) d.style.setProperty('height', Math.ceil(vh - top) + 'px', 'important');
  }
  document.addEventListener('toggle', function (e) {
    if (e.target.matches && e.target.matches('header-drawer > details') && e.target.open) {
      fitDrawer(); requestAnimationFrame(fitDrawer); setTimeout(fitDrawer, 350);
    }
  }, true);
  window.addEventListener('resize', fitDrawer, { passive: true });
  if (window.visualViewport) window.visualViewport.addEventListener('resize', fitDrawer, { passive: true });

  // A department panel always opens at the top (not where it was last scrolled to).
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (!d.open || !d.matches || !d.matches('.menu-drawer__navigation > .menu-drawer__menu > li > details')) return;
    var inner = d.querySelector('.menu-drawer__inner-submenu');
    if (inner) inner.scrollTop = 0;
    // Department top sellers strip (same section as the desktop panes)
    var box = d.querySelector('[data-yc-drawer-top]');
    if (box && !box.__ycLoaded) {
      box.__ycLoaded = true;
      // reserve the strip's height while it loads, so the list below doesn't jump
      box.hidden = false;
      box.classList.add('yc-drawer-top--loading');
      var url = box.getAttribute('data-yc-drawer-top');
      fetchTop(url)
        .then(function (html) {
          var list = new DOMParser().parseFromString(html, 'text/html').querySelector('.yc-mm-products');
          box.classList.remove('yc-drawer-top--loading');
          if (!list || !list.children.length) { box.hidden = true; return; }
          box.querySelector('[data-yc-mm-top-body]').appendChild(list);
        })
        .catch(function () { box.__ycLoaded = false; box.hidden = true; box.classList.remove('yc-drawer-top--loading'); });
    }
  }, true);

  // ---------- GA4: menu clicks ----------
  // One `menu_click` event per link clicked in the desktop mega-menu or the phone drawer.
  // Uses GA4's built-in link dimensions so nothing needs registering in GA4 Admin:
  //   link_text    = menu path, e.g. "Music > Vinyl > Rock Vinyl"
  //   link_url     = destination
  //   link_classes = "<desktop|phone>:<kind>" (kind: department, shop_all, quick, category, sub, more,
  //                  top_seller, promo, chip, more_in, help, account, page)
  var clean = function (t) { return (t || '').replace(/\s+/g, ' ').replace(/[›→]/g, '').trim(); };
  function menuPath(a, phone) {
    var parts = [];
    if (phone) {
      var dept = a.closest('.menu-drawer__navigation > .menu-drawer__menu > li');
      var deptLabel = dept && dept.querySelector(':scope > details > summary .yc-row-label');
      if (deptLabel) parts.push(clean(deptLabel.textContent));
      var sub = a.closest('.menu-drawer__inner-submenu details');
      var subLabel = sub && sub.querySelector(':scope > summary .yc-row-label');
      if (subLabel && sub.querySelector('summary') !== a) parts.push(clean(subLabel.textContent));
    } else {
      var item = a.closest('.header-inline-menu__item');
      var top = item && item.querySelector('.header-inline-menu__item-label');
      if (top) parts.push(clean(top.getAttribute('title') || top.textContent)); // full name, so reports stay comparable
      var pane = a.closest('.yc-mm__pane');
      var title = pane && pane.querySelector('.yc-mm__title');
      if (title && !a.classList.contains('yc-mm__tab')) parts.push(clean(title.textContent));
    }
    var own = a.classList.contains('yc-mm-prod') ? clean((a.querySelector('.yc-mm-prod__title') || a).textContent).slice(0, 60) : clean(a.textContent);
    if (own && own !== parts[parts.length - 1]) parts.push(own);
    return parts.join(' > ').slice(0, 100);
  }
  function menuKind(a, phone) {
    if (a.classList.contains('yc-mm-prod')) return 'top_seller';
    if (a.classList.contains('yc-mm__promo')) return 'promo';
    if (a.classList.contains('yc-mm__all') || a.classList.contains('yc-shop-all')) return 'shop_all';
    if (a.classList.contains('yc-mm__tab--quick') || a.classList.contains('yc-shop-quick')) return 'quick';
    if (a.classList.contains('yc-quick__more')) return 'more_in';
    if (a.closest('.yc-quick')) return 'chip';
    if (a.closest('.yc-help')) return 'help';
    if (a.classList.contains('yc-top-login') || a.classList.contains('yc-account-link')) return 'account';
    if (a.classList.contains('yc-mm__tab')) return 'category';
    if (a.classList.contains('yc-mm__more')) return 'more';
    if (a.classList.contains('header-inline-menu__item-link')) return 'department';
    if (a.closest('.yc-mm__links') || a.classList.contains('grandchildlink')) return 'sub';
    return phone ? 'category' : 'link';
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href]');
    if (!a || typeof window.gtag !== 'function') return;
    var phone = !!a.closest('#menu-drawer');
    if (!phone && !a.closest('.header-inline-menu')) return;
    try {
      window.gtag('event', 'menu_click', {
        link_text: menuPath(a, phone),
        link_url: a.href,
        link_classes: (phone ? 'phone:' : 'desktop:') + menuKind(a, phone),
        transport_type: 'beacon',
      });
    } catch (err) { /* never block navigation */ }
  }, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
